import { partition } from 'util/array'

/**
 * Filtra uma lista e retorna um objeto contendo
 * os itens que são recentes e os itens que são de
 * registro anterior.
 * @param items Uma lista de objetos
 * @param key Nome da propriedade que define um registro anterior
 * @returns {{recentes: T[], registroAnterior: T[]}} Objeto com uma lista de registros
 * recentes e uma de registros anteriores
 */

export const filterByRegistroAnterior = <T>(
  items: ReadonlyArray<T>,
  key: string
): { recentes: ReadonlyArray<T>; registroAnterior: ReadonlyArray<T> } => {
  const [registroAnterior, recentes] = partition(items, (item) => item[key])
  return { recentes, registroAnterior }
}
